import { GetData } from "./Functions/SettingData";
import qs from "qs";

export const getFleetEnergyEvents = async (params) => {
  var config = {
    method: "get",
    url: `/api/fleet/energy-events`,
    params,
    headers: {
      "Content-Type": "application/json",
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
};

export const fleetEnergyEventsAction = async (actionData) => {
  var config = {
    method: "post",
    url: `/api/fleet/energy-events/list-action`,
    headers: {
      "Content-Type": "application/json",
    },
    data: actionData,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
};
